/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from 'axios';
import { RUNTIME } from '@src/slide/infrastructure/module/dependent/config/tob/constant';
import { VipType } from '@src/js/common/ark-extensions/dc-components/avatar-nick-nameplate/type';
import { getXSRF } from '@src/slide/domain/slide-app/utils/cookie-utils';

const docsBaseUrl = RUNTIME.API_ROOT;
/**
 * 设置文档标题
 */
const DOC_CHANGE_TITLE = 'SET_AUTH_INFO';
/**
 * 24小时权限申请检查
 */
const GET_AUTH_APPLY_CHECK = 'GET_AUTH_APPLY_CHECK';
/**
 * 获得用户备注、头像，用于 用户列表获取
 */
export const GET_USER_AVATAR_MARKNAME = 'GET_USER_AVATAR_MARKNAME';

const CGI_PATH = {
    [DOC_CHANGE_TITLE]: `${docsBaseUrl}cgi-bin/online_docs/doc_changetitle`,
    [GET_USER_AVATAR_MARKNAME]: `${docsBaseUrl}sdc/getusermarkname`,
};

/**
 * 设置文档标题
 * @param title 文档标题
 * @param domainId
 * @param padId
 */
export function updateTitle(title: string, domainId: string, padId: string) {
    return axios.post(`${CGI_PATH[DOC_CHANGE_TITLE]}?pad_id=${padId}&type=1&ver=2&domain_id=${domainId}&xsrf=${getXSRF()}&version=2&auto_change=0&title=${encodeURIComponent(title)}`);
}

/**
 * 获取文档信息
 */
export const getDocInfo = (domainId: string, padId: string, callback: (...args: unknown[]) => unknown) => {
    const url = `${RUNTIME.API_ROOT}cgi-bin/online_docs/doc_info?domainId=${domainId}&localPadId=${padId}`;
    axios.get(url).then((data: any) => {
        const docMeta = data?.data?.doc_meta;
        if (docMeta) {
            callback(transformDocInfo(data.data));
        }
    })
        .catch(() => {});
};

export const transformDocInfo = (docInfo: any) => {
    const docMeta = docInfo.doc_meta;
    return {
        personalizeInfo: docMeta?.personalize_info,
        docType: docMeta?.doc_type,
        ownerNick: docInfo.owner_nick,
        ownerAvatar: docInfo.owner_avatar,
        // 认证相关信息
        certification: {
            isCertification: !!docMeta?.official_auth_info,      // 是否显示认证标签
            certificationAvatar: docMeta?.avatar, // 认证帐号头像
            certificationNick: docMeta?.official_auth_info?.nick,     // 认证帐号名称
            certificationType: docMeta?.official_auth_info?.type,     // 认证帐号类型
            certificationSubject: docMeta?.official_auth_info?.principal, // 认证帐号主体
        },
    };
};

// 获取用户 vip level 信息
export const getOwnerVipLevel = (padId: string): Promise<{ vipLevel: VipType; isExpired: boolean }> => axios
    .post(`${RUNTIME.API_ROOT}api/personalize/owner/viplevel`, { file_id: padId, get_all: true })
    .then(({ data }) => {
        // expiredStatus 为 1 时过期，0 时未过期
        const vipInfo = JSON.parse(data?.result?.vip_info);
        const isExpired = vipInfo.expire_status === 1;
        const vipLevel: VipType = {
            1: VipType.NONE,
            2: VipType.NORMAL,
            3: VipType.SUPER,
            4: VipType.SUPER_PLUS,
        }[data?.result?.vip_level] || VipType.NONE;
        return { vipLevel, isExpired };
    })
    .catch(() => ({ vipLevel: VipType.NONE, isExpired: false }));
